import React, { SVGProps } from 'react'
export const SecondDefaultRightSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M14.376 14.7C12.978 10.505 9.164 6.523 0 4V3c9.337 2.57 13.75 6.746 15.293 11.374 1.528 4.587.298 9.46-1.03 13.283-.781 2.248-2.681 3.85-5.167 4.998-2.49 1.15-5.7 1.88-9.096 2.345v-.992c3.357-.46 6.333-1.173 8.7-2.266 2.37-1.095 3.996-2.539 4.65-4.423 1.32-3.798 2.437-8.382 1.026-12.62Z"
      clipRule="evenodd"
    />
  </svg>
)
